import { GetStaticPaths, GetStaticProps } from 'next'

import query, { EXTRA, PAGES } from './queries'
import ROUTE from './route'

import initApollo, { API } from 'src/api'

const HELP_CENTER_TOPIC: Record<API.ProductCourseSubject, string> = {
  CODE: 'code',
  DESIGN: 'design',
  PROJECT_MANAGEMENT: 'project-management',
}

export const getStaticPaths: GetStaticPaths = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.Course_pages>({
    query: PAGES,
  })

  const paths =
    data.productCourses?.nodes?.map((item) => ROUTE.path({ courseSlug: item.slug })) || []

  return { paths, fallback: false }
}

export type Props = API.Course_productCourse & API.Course_extra

export const getStaticProps: GetStaticProps<Props, { slug: string }> = async ({
  params,
  preview,
}) => {
  const client = initApollo({})

  const { data } = await client.query<API.Course, API.CourseVariables>({
    query,
    variables: {
      slug: params?.slug as unknown as string,
      statuses: preview ? [API.ProductStatus.LIVE, API.ProductStatus.DRAFT] : undefined,
    },
  })

  if (!data.productCourse) {
    throw new Error()
  }

  const { data: extraData } = await client.query<API.Course_extra, API.Course_extraVariables>({
    query: EXTRA,
    variables: {
      otherCoursesSubject: data.productCourse.subjects[0],
    },
  })

  let otherCourses: API.Course_extra['otherCourses'] = extraData.otherCourses

  if (otherCourses?.nodes) {
    otherCourses = {
      ...otherCourses,
      nodes: (
        extraData.otherCourses?.nodes.filter(
          (course) => course.slug !== (params?.slug as unknown as string),
        ) || []
      ).slice(0, 3),
    }
  }

  return {
    props: {
      ...data.productCourse,
      ...extraData,
      otherCourses,
    },
  }
}
